import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { i18n } from '../../../i18n/index.js';
import { Layout } from '../Layout/component.js';
import { Icon } from '../Icon/component.js';
var ShowHidePasswordButton = function ShowHidePasswordButton(_ref) {
  var showPassword = _ref.showPassword,
    toggleShowPassword = _ref.toggleShowPassword;
  return /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": showPassword ? i18n.t('Hide password') : i18n.t('Show password'),
    variant: "ghost",
    paddingX: 0,
    isRound: true,
    onClick: toggleShowPassword,
    icon: /*#__PURE__*/React.createElement(Layout, {
      pointerEvents: "none"
    }, /*#__PURE__*/React.createElement(Icon, {
      iconName: showPassword ? 'eye-slash' : 'eye',
      prefix: "fas"
    }))
  });
};
ShowHidePasswordButton.displayName = "ShowHidePasswordButton";
export { ShowHidePasswordButton };